import { useParams, Link } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';
import { categories, categoryArticles } from '@/mocks/categoryData';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? categories[slug] : undefined;
  const articles = slug ? categoryArticles[slug] || [] : [];

  useSEO({
    title: category ? `${category.name} | 51爆料 - 吃瓜爆料黑料第一站` : '全部分类 | 51爆料 - 网红翻车·擦边反差·明星黑料',
    description: category
      ? `${category.description} 51爆料${category.name}栏目，24小时实时更新，深度追踪每一条线索。`
      : '51爆料全部分类：网红翻车、擦边反差、明星黑料。吃瓜爆料黑料第一站，24小时实时更新热点大瓜，深度追踪每一条线索。',
    keywords: category
      ? `51爆料,${category.name},网红翻车,擦边反差,明星黑料,吃瓜爆料,热点事件`
      : '51爆料,网红翻车,擦边反差,明星黑料,吃瓜爆料,分类导航,独家速报',
    url: category
      ? `https://www.51baoliao.com/category/${category.slug}`
      : 'https://www.51baoliao.com/category',
    type: 'webpage',
    breadcrumbs: [
      { name: '首页', url: 'https://www.51baoliao.com/' },
      ...(category ? [{ name: category.name, url: `https://www.51baoliao.com/category/${category.slug}` }] : [{ name: '全部分类', url: 'https://www.51baoliao.com/category' }]),
    ],
  });

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="pt-24">
          <div className="w-full bg-background-50 border-b border-background-200/70 px-4 md:px-6 py-3">
            <nav aria-label="面包屑导航">
              <ol className="flex items-center gap-2 text-sm">
                <li>
                  <Link to="/" className="text-foreground-500 hover:text-foreground-700 transition-colors">首页</Link>
                </li>
                <li className="text-foreground-300"><i className="ri-arrow-right-s-line text-xs"></i></li>
                <li className="text-primary-600 font-medium" aria-current="page">全部分类</li>
              </ol>
            </nav>
          </div>

          <section className="w-full bg-background-50 py-14 md:py-20">
            <div className="w-full px-4 md:px-6">
              <div className="text-center mb-10 md:mb-14">
                <div className="inline-flex items-center gap-2 mb-4">
                  <span className="w-3 h-3 bg-accent-500 rounded-full"></span>
                  <span className="text-accent-700 text-xs font-semibold uppercase tracking-wider">分类导航</span>
                </div>
                <h1 className="font-heading text-3xl md:text-5xl font-black text-foreground-950">
                  探索爆料分类
                </h1>
                <p className="text-foreground-400 text-sm md:text-base mt-3 max-w-md mx-auto">
                  选择一个你感兴趣的分类，开始吃瓜之旅
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                {Object.values(categories).map((cat) => {
                  const catArticles = categoryArticles[cat.slug] || [];
                  return (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-300/40 transition-all"
                    >
                      <div className="w-full aspect-[16/10] overflow-hidden">
                        <img
                          src={cat.heroImage}
                          alt={cat.name}
                          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                          title={cat.name}
                        />
                      </div>
                      <div className="p-5 md:p-6">
                        <h2 className="text-foreground-950 text-lg md:text-xl font-bold mb-1.5">{cat.name}</h2>
                        <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-3">{cat.description}</p>
                        <div className="flex items-center justify-between">
                          <span className="text-foreground-300 text-xs">{catArticles.length} 篇内容</span>
                          <span className="inline-flex items-center gap-1 text-primary-500 text-xs font-semibold group-hover:gap-2 transition-all">
                            进入
                            <i className="ri-arrow-right-line text-xs"></i>
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </>
    );
  }

  const featured = articles[0];
  const rest = articles.slice(1);

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full min-h-[420px] md:min-h-[500px] flex items-end overflow-hidden bg-background-100 pt-24">
          <div className="absolute inset-0">
            <img
              src={category.heroImage}
              alt={`${category.name}分类封面`}
              className="w-full h-full object-cover object-top"
              title={`${category.name}分类封面`}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-black/30"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 pb-10 md:pb-14">
            <div className="flex flex-col lg:flex-row items-start lg:items-end gap-6 lg:gap-16">
              <div className="flex-1">
                <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight tracking-tight">
                  {category.name}
                </h1>
              </div>
              <div className="flex-1 lg:pb-1">
                <p className="text-background-50/70 text-sm md:text-base leading-relaxed mb-3 max-w-md">
                  {category.description}
                </p>
                <Link
                  to="/"
                  className="group inline-flex items-center gap-2 text-accent-500 font-semibold text-sm hover:text-accent-400 transition-colors cursor-pointer"
                >
                  查看更多分类
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Breadcrumb */}
        <div className="w-full bg-background-50 border-b border-background-200/70 px-4 md:px-6 py-3">
          <nav aria-label="面包屑导航">
            <ol className="flex items-center gap-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-500 hover:text-foreground-700 transition-colors">首页</Link>
              </li>
              <li className="text-foreground-300"><i className="ri-arrow-right-s-line text-xs"></i></li>
              <li className="text-primary-600 font-medium" aria-current="page">
                {category.name}
              </li>
            </ol>
          </nav>
        </div>

        {/* Category Tabs */}
        <div className="w-full bg-background-50 border-b border-background-200/70 px-4 md:px-6 py-3">
          <div className="flex items-center gap-2 overflow-x-auto">
            {Object.values(categories).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-5 py-2.5 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:text-foreground-950 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        {/* Content Grid */}
        <section className="w-full bg-background-100 py-10 md:py-14">
          <div className="w-full px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-16 mb-8 md:mb-12">
              <div className="lg:w-1/3">
                <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-none tracking-tight">
                  塌房全记录
                </h2>
              </div>
              <div className="lg:w-2/3">
                <p className="text-foreground-500 text-sm">
                  筛选条件：全部 · 按时间排序 · {articles.length} 篇内容
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
              {/* Featured Article */}
              {featured && (
                <Link
                  to={`/article/${featured.slug}`}
                  className="group bg-foreground-900 rounded-2xl p-5 md:p-6 flex flex-col cursor-pointer"
                >
                  <h3 className="text-background-50 text-lg md:text-xl font-bold mb-2 leading-snug">
                    {featured.title}
                  </h3>
                  <p className="text-background-50/60 text-sm leading-relaxed mb-4">
                    {featured.subtitle}
                  </p>
                  <div className="w-full aspect-[16/10] rounded-xl overflow-hidden mt-auto">
                    <img
                      src={featured.image}
                      alt={featured.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      title={featured.title}
                    />
                  </div>
                </Link>
              )}

              {/* Rest Articles */}
              {rest.slice(0, 2).map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col cursor-pointer border border-background-200/60"
                >
                  <div className="flex items-center gap-2 mb-3">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
                      <i className="ri-fire-line text-xs"></i>
                      {article.tag}
                    </span>
                  </div>
                  <div className="w-full aspect-[16/10] rounded-xl overflow-hidden mb-4">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                      title={article.title}
                    />
                  </div>
                  <h3 className="text-foreground-950 text-base md:text-lg font-bold leading-snug mb-1.5">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-xs mb-4">
                    {article.subtitle}
                  </p>
                  <div className="mt-auto flex items-center gap-2">
                    <span className="inline-flex items-center gap-1.5 bg-primary-500 text-background-50 text-xs font-semibold px-4 py-2 rounded-full group-hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                      阅读全文
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>

            {/* More Articles Grid */}
            {rest.length > 2 && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-5 md:mt-6">
                {rest.slice(2).map((article) => (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-2xl p-5 md:p-6 flex flex-col cursor-pointer border border-background-200/60"
                  >
                    <div className="flex items-center gap-2 mb-3">
                      <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full">
                        <i className="ri-fire-line text-xs"></i>
                        {article.tag}
                      </span>
                    </div>
                    <div className="w-full aspect-[16/10] rounded-xl overflow-hidden mb-4">
                      <img
                        src={article.image}
                        alt={article.title}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                        title={article.title}
                      />
                    </div>
                    <h3 className="text-foreground-950 text-base md:text-lg font-bold leading-snug mb-1.5">
                      {article.title}
                    </h3>
                    <p className="text-foreground-500 text-xs mb-4">
                      {article.subtitle}
                    </p>
                    <div className="mt-auto flex items-center justify-between">
                      <span className="text-foreground-300 text-xs">{article.date}</span>
                      <span className="inline-flex items-center gap-1 bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1.5 rounded-full group-hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer">
                        阅读
                        <i className="ri-arrow-right-line text-xs"></i>
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>

        {/* Stats Section */}
        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="mb-10 md:mb-14">
              <p className="text-foreground-400 text-xs font-semibold uppercase tracking-wider mb-3">
                数据说话
              </p>
              <p className="text-foreground-700 text-base md:text-lg leading-relaxed max-w-2xl">
                51爆料深耕{category.name}领域多年，积累了丰富的信源和数据。每一条爆料都经过严格审核，确保真实可靠。
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6 md:gap-10">
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl md:text-6xl font-black text-foreground-950">
                    {category.stats.weeklyCount}
                  </span>
                  <span className="text-accent-500 text-xl md:text-3xl font-bold">+</span>
                </div>
                <p className="text-foreground-400 text-sm mt-1">本周爆料数</p>
              </div>
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl md:text-6xl font-black text-foreground-950">
                    {category.stats.involvedCount}
                  </span>
                  <span className="text-accent-500 text-xl md:text-3xl font-bold">+</span>
                  <span className="text-foreground-400 text-lg">位</span>
                </div>
                <p className="text-foreground-400 text-sm mt-1">涉事网红/明星</p>
              </div>
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl md:text-6xl font-black text-foreground-950">
                    {category.stats.truthRate}
                  </span>
                </div>
                <p className="text-foreground-400 text-sm mt-1">内容真实率</p>
              </div>
              <div>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-4xl md:text-6xl font-black text-foreground-950">
                    {category.stats.onlineHours}
                  </span>
                  <span className="text-foreground-400 text-lg">小时</span>
                </div>
                <p className="text-foreground-400 text-sm mt-1">实时值班监控</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}